import React, { useState, useRef } from 'react';

type UsePhoneNumberPadReturn = {
  digits: string;
  phoneNumber: string;
  inputRef: React.RefObject<HTMLInputElement>;
  handleNumberClick: (number: number | string) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formatPhoneNumber: (phone: string) => string;
  showCursor: boolean;
  formattedPhone: string;
  setPhoneNumber: (phoneNumber: string) => void;
};

export function usePhoneNumberPad(): UsePhoneNumberPadReturn {
  const [phoneNumber, setPhoneNumber] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleNumberClick = (number: number | string): void => {
    if (number === '<-') {
      setPhoneNumber((prev) => prev.slice(0, -1));
    } else {
      setPhoneNumber((prev) => {
        const newPhoneNumber = prev + String(number);
        return newPhoneNumber.length <= 10 ? newPhoneNumber : prev;
      });
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const value = e.target.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 10) {
      setPhoneNumber(value);
    }
  };

  const formatPhoneNumber = (phone: string): string => {
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 0) {
      return '';
    }

    const lastFour = digits.slice(-4);
    const { length } = digits;

    if (length <= 4) {
      return digits;
    }
    if (length <= 7) {
      return `${'*'.repeat(length - 4)} ${lastFour}`;
    }
    return `(***) ${'*'.repeat(length - 7)} ${lastFour}`;
  };

  const digits = phoneNumber.replace(/\D/g, '');
  const showCursor = digits.length < 10;
  const formattedPhone = formatPhoneNumber(phoneNumber);

  return {
    digits,
    phoneNumber,
    inputRef,
    handleNumberClick,
    handleInputChange,
    formatPhoneNumber,
    showCursor,
    formattedPhone,
    setPhoneNumber,
  };
}
